import { useEffect, useMemo } from 'react';
import { ThemeProvider, createTheme, useMediaQuery } from "@mui/material";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "./App.css";
import Home from "./components/Home";
import MyAccount from "./components/MyAccount";
import Premium from "./components/Premium";
import { getUserAuth } from "./store/actions";
import { connect } from 'react-redux';

// MUI controls (search, photo upload) follow the same brand palette and
// light / dark mode as the styled-components tokens in index.css.
const buildTheme = (mode) => createTheme({
  palette: {
    mode,
    primary: mode === 'dark'
      ? { main: '#f8e9a1', contrastText: '#24305e' }
      : { main: '#374785', contrastText: '#fefefe' },
    secondary: { main: '#f76c6c', contrastText: '#1e2650' },
    background: mode === 'dark'
      ? { default: '#12172e', paper: '#1a2142' }
      : { default: '#fafafc', paper: '#fefefe' },
    text: mode === 'dark'
      ? { primary: '#eceef6', secondary: '#a3a9c4' }
      : { primary: '#1e2650', secondary: '#5b6280' },
  },
  shape: { borderRadius: 12 },
  typography: {
    fontFamily: '"Manrope", system-ui, -apple-system, "Segoe UI", sans-serif',
    h5: { fontFamily: '"Outfit", system-ui, sans-serif', fontWeight: 600, letterSpacing: '-0.02em' },
    button: { textTransform: 'none', fontWeight: 600, fontFamily: '"Outfit", system-ui, sans-serif' },
  },
  components: {
    MuiButton: {
      defaultProps: { disableElevation: true },
      styleOverrides: {
        root: {
          borderRadius: 999,
          minHeight: 44,
          paddingInline: 22,
          transition: 'transform 0.3s cubic-bezier(0.16, 1, 0.3, 1), background-color 0.2s ease',
          '&:active': { transform: 'scale(0.98)' },
        },
      },
    },
  },
});

function App(props) {
  useEffect(() => {
    props.getUserAuth();
  }, [props]);

  const prefersDark = useMediaQuery('(prefers-color-scheme: dark)');
  const theme = useMemo(() => buildTheme(prefersDark ? 'dark' : 'light'), [prefersDark]);

  return (
    <ThemeProvider theme={theme}>
    <div className="App">
      <Router>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/home" element={<Home />} />
          <Route path="/register" element={<Home page="register" />} />
          <Route path="/login" element={<Home page="login" />} />
          <Route path="/account" element={<MyAccount />} />
          <Route path="/premium" element={<Premium />} />
        </Routes>
      </Router>
    </div>
    </ThemeProvider>
  );
}

const mapStateToProps = (state) => {
  return {};
}

const mapDispatchToProps = (dispatch) => ({
  getUserAuth: () => dispatch(getUserAuth()),
});

export default connect(mapStateToProps, mapDispatchToProps)(App);
